import React, { useRef, useState, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import Header from "../../Common/header";
import Footer from "../../Common/footer";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import Select from "react-select";
import PostalCode from "./UTIL/canadianPostalCodeTest";
import StepsNavbar from './Components/stepsNavbar';
import {
  formatPostal, unformatPostal,
  formatPhoneNumber, unformatPhoneNumber
} from "../../Common/formatInput";

import {
  HiPlus,
  HiOutlineTrash
} from "react-icons/hi";
import { ReactTags } from "react-tag-autocomplete";

const PIrole = [
  { value: "Principal Investigator", label: "Principal Investigator" },
  { value: "Party Chief", label: "Party Chief" },
  { value: "Electronics Technician", label: "Electronics Technician" },
  { value: "Marine Surveyor", label: "Marine Surveyor" },
  { value: "Project Manager", label: "Project Manager" },
  { value: "Data Scientist", label: "Data Scientist" },
  { value: "Data Curator", label: "Data Curator" },
  { value: "Research Assistant", label: "Research Assistant" },
];

const affiliation = [
  { value: "Arctic Basecamp", label: "Arctic Basecamp" },
  { value: "Arctic Council", label: "Arctic Council" },
  { value: "Arctic Institute of North America", label: "Arctic Institute of North America" },
  { value: "Arctic Research Foundation", label: "Arctic Research Foundation" },
  { value: "Canada Foundation for Innovation", label: "Canada Foundation for Innovation" },
  { value: "Canadian Energy", label: "Canadian Energy" },
  { value: "Canadian High Arctic Research Station (CHARS)", label: "Canadian High Arctic Research Station (CHARS)" },
  { value: "Canadian Hydrographic Service", label: "Canadian Hydrographic Service" },
  { value: "Canadian Ice Service", label: "Canadian Ice Service" },
  { value: "Canadian Northern Economic Development Agency", label: "Canadian Northern Economic Development Agency" },
  { value: "Canadian Space Agency", label: "Canadian Space Agency" },
  { value: "Centre for International Governance Innovation", label: "Centre for International Governance Innovation" },
  { value: "Ekaluktutiak Hunters and Trappers Organization", label: "Ekaluktutiak Hunters and Trappers Organization" },
  { value: "Ekaluktutiak Hunters & Trappers Organization", label: "Ekaluktutiak Hunters & Trappers Organization" },
  { value: "Fisheries and Oceans Canada", label: "Fisheries and Oceans Canada" },
  { value: "Future Earth", label: "Future Earth" },
  { value: "Gjoa Haven Hunters and Trappers Association", label: "Gjoa Haven Hunters and Trappers Association" },
  { value: "Government of Nunavut", label: "Government of Nunavut" },
  { value: "Ideal Supply", label: "Ideal Supply" },
  { value: "Inuit Qaujisarvingat", label: "Inuit Qaujisarvingat" },
  { value: "Kitikmeot Inuit Association", label: "Kitikmeot Inuit Association" },
  { value: "Kitnuna Group of Companies", label: "Kitnuna Group of Companies" },
  { value: "McGill University", label: "McGill University" },
  { value: "Memorial University", label: "Memorial University" },
  { value: "Ocean Networks Canada", label: "Ocean Networks Canada" },
  { value: "Ocean Tracking Network", label: "Ocean Tracking Network" },
  { value: "OpenCanada", label: "OpenCanada" },
  { value: "Parks Canada", label: "Parks Canada" },
  { value: "Polar Bears International", label: "Polar Bears International" },
  { value: "Polar Knowledge Canada", label: "Polar Knowledge Canada" },
  { value: "Queen's University", label: "Queen's University" },
  { value: "Royal Canadian Navy", label: "Royal Canadian Navy" },
  { value: "The Dark Mountain Project", label: "The Dark Mountain Project" },
  { value: "The University of Alaska Fairbanks", label: "The University of Alaska Fairbanks" },
  { value: "Tradition + Transition", label: "Tradition + Transition" },
  { value: "Univeristy of Windsor", label: "Univeristy of Windsor" },
  { value: "University of British Columbia", label: "University of British Columbia" },
  { value: "University of Calgary", label: "University of Calgary" },
  { value: "University of Manitoba", label: "University of Manitoba" },
  { value: "University of New Brunswick", label: "University of New Brunswick" },
  { value: "University of Tromsø", label: "University of Tromsø" },
  { value: "University of Victoria", label: "University of Victoria" },
  { value: "University of Winnipeg", label: "University of Winnipeg" },
  { value: "Wilfrid Laurier University", label: "Wilfrid Laurier University" },
  { value: "Other", label: "Other" },
];

export default function ProjectContributorsInformation(props) {
  const projectData = props.projectData;
  const setProjectData = props.setProjectData;
  const [, forceUpdate] = useState();
  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      MB: PostalCode.Manitoba(),
      AB: PostalCode.Alberta(),
      NL: PostalCode.NewfoundlandAndLabrador(),
      PE: PostalCode.PrinceEdwardIsland(),
      NS: PostalCode.NovaScotia(),
      QC: PostalCode.Quebec(),
      NB: PostalCode.NewBrunswick(),
      ON: PostalCode.Ontario(),
      SK: PostalCode.Saskatchewan(),
      BC: PostalCode.BritishColumbia(),
      YT: PostalCode.Yukon(),
      NT: PostalCode.NorthwestTerritories(),
      NU: PostalCode.Nunavut(),
      zipCode: {
        // name the rule
        message: "The :attribute must meet the requirements",
        rule: (val, params, validator) => {
          return validator.helpers.testRegex(
            val,
            /(^\d{5}$)|(^\d{5}-\d{4}$)/
          );
        },
        required: true, // optional
      },
    },
  }))

  /**
   * Checks if all fields are valid. If all fields are valid, it calls the nextPage() function to move to the next page. 
   * If there are invalid fields, it displays the validation messages for the invalid fields and scrolls to the top.
   * @param {*} e Event object
   */
  function next(e) {
    e.preventDefault();
    if (simpleValidator.current.allValid()) {
      props.nextPage();
    } else {
      simpleValidator.current.showMessages();
      window.scrollTo(0, 0);
      // rerender to show messages for the first time
      forceUpdate(1);
    }
  };

  /**
   * Moves the user to the previous page
   * @param {*} e Event object
   */
  function previous(e) {
    e.preventDefault();
    props.previousPage();
  };

  /**
   * Handles changes in the input fields of the form. The function updates the state object properties based on the input field that was passed into the change event.
   * @param {*} e Event object
   * @param {*} input Name of state property to update
   */
  function handleChange(e, input) {
    if (input === "piPhone") {
      setProjectData((prevState) => ({
        ...prevState,
        piPhone: unformatPhoneNumber(e.target.value),
        tempPhone: formatPhoneNumber(e.target.value),
      }));
    } else if (input === "piPostalCode") {
      setProjectData((prevState) => ({
        ...prevState,
        piPostalCode: unformatPostal(e.target.value),
        tempPostalCode: formatPostal(e.target.value),
      }));
    } else if (input === "piZipCode") {
      setProjectData((prevState) => ({
        ...prevState,
        piPostalCode: e.target.value.trim(),
        tempPostalCode: e.target.value.trim(),
      }));
    } else {
      setProjectData((prevState) => ({
        ...prevState,
        [input]:
          typeof e.target.value === "string"
            ? e.target.value.trim()
            : e.target.value,
      }));
    }
  };

  function selectCountry(val) {
    setProjectData((prevState) => ({
      ...prevState,
      piCountry: val,
      piProvince: ""
    }));
  };

  function selectRegion(val) {
    setProjectData((prevState) => ({
      ...prevState,
      piProvince: val,
    }));
  };

  function handleRole(piRole) {
    setProjectData((prevState) => ({
      ...prevState,
      piRole: piRole.value,
    }));
  };

  function handleAffiliation(piAffiliation) {
    setProjectData((prevState) => ({
      ...prevState,
      piAffiliation: piAffiliation.value,
    }));

    if (projectData.piAffiliation.value !== "Other") {
      setProjectData((prevState) => ({
        ...prevState,
        inputPiAffiliation: "",
      }));
    }
  };

  /**
   * Handles the changing of names, emails, and ORCID of contributors. Updates the contributorList state based on the changes made to the contributor input.
   * @param {*} e Event object
   * @param {*} index  Index of the contributor whose properties were changed in contributorList array
   */
  function handleChangeContributor(e, index) {
    const { name, value } = e.target;
    const contributorList = [...projectData.contributorList];
    contributorList[index][name] = value;

    setProjectData((prevState) => ({
      ...prevState,
      contributorList: contributorList,
    }));
  };

  /**
   * Handles the changing of the role of the co-investigator. Updates the contributorList state based on the changes made to the co-investigator role input.
   * @param {*} role Role to give to co-investigator
   * @param {*} index Index of the contributor whose properties were changed in contributorList array
   */

  function onRoleTagAddition(contributorIdx, tag) {
    const updatedContributors = [...projectData.contributorList];
    if(!updatedContributors[contributorIdx].roles) {
        updatedContributors[contributorIdx].roles = [];
    }

    // Append the new role
    updatedContributors[contributorIdx].roles.push(tag.value);

    // Filter out any null or undefined roles
    const cleanRoles = updatedContributors[contributorIdx].roles.filter(role => role !== null && role !== undefined);
    updatedContributors[contributorIdx].roles = cleanRoles;

    setProjectData(prevState => ({
        ...prevState,
        contributorList: updatedContributors
    }));
}

  function onRoleTagDelete(contributorIdx, roleIdx) {
    const updatedContributors = [...projectData.contributorList];
    if (updatedContributors[contributorIdx] && updatedContributors[contributorIdx].roles) {
      updatedContributors[contributorIdx].roles.splice(roleIdx, 1);
    }

    setProjectData(prevState => ({
      ...prevState,
      contributorList: updatedContributors
    }));
  }

  /**
   * Creates an array of objects that contain the contributor's role in the value and label properties. This is used to display the role chips in ReactTags since they require the value and label properties.
   * @param {Array} roles Array of contributor roles. 
   * @returns Array of objects that contain the value and label properties of the contributor's role.
   */
  function getContributorRoleChips(roles) {
    let roleChips = [];
    /* if (roles === undefined || roles === null || roles.length === 0) {
      return roleChips;
    } */
    roles.map((role) => {
      roleChips.push({
        value: role,
        label: role
      });
    });
    return roleChips;
  }

  // Handles co-investigator research affiliation input changes
  function handleChangeContributorAffiliation(affiliation, index) {
    const contributorList = [...projectData.contributorList];
    contributorList[index].affiliation = affiliation.value;

    setProjectData((prevState) => ({
      ...prevState,
      contributorList: contributorList,
    }));
  };

  /**
   * Adds a new contributor object to the contributorList state variable.
   */
  function addNewContributor() {
    const contributorList = [...projectData.contributorList];
    contributorList.push({
      name: "",
      roles: [],  
      email: "",
      affiliation: "",
      ORCID: "",
      inputAffiliation: "",
      inputRole: "",
    });
    setProjectData((prevState) => ({
      ...prevState,
      contributorList: contributorList,
    }));
  };

  /**
   * Removes a contributor object from the contributorList array based on the index provided.
   * @param {*} index Index of contributor object to remove from contributorList array
   */
  function clickOnDelete(index) {
    const contributorList = [...projectData.contributorList];
    contributorList.splice(index, 1);
    setProjectData((prevState) => ({
      ...prevState,
      contributorList: contributorList,
    }));
    const newValidators = { ...simpleValidator.current.fields };

    delete newValidators[`Co-Investigator ${index} Role`];
    delete newValidators[`Co-Investigator ${index} Name`]

    simpleValidator.current.fields = newValidators;
  };
   return (
    <>
      <Header />

      <StepsNavbar currentStep={props.step} setStep={props.setStep} next={next} />

      <div className="overflow-hidden dark:bg-gray-900">
      <div className="max-w-2xl my-8 sm:my-12 m-auto bg-white border dark:bg-gray-800 dark:border-gray-700">
      <form>
          <div className="bg-gray-100 dark:bg-gray-800">
            <div>
              <h2 className=" text-center font-bold text-gray-900 sm:text-xl sm:tracking-tight lg:text-3xl py-6 border-b-2 mb-8 dark:border-gray-600 dark:text-gray-100">
                Project Contributors Information
              </h2>
            </div>
            <div className="px-8">
              {/* Publisher Section ------------------------------------------------------ */}
              <div className="md:col-span-1 mb-6">
                <div className="">
                  <h3 className="text-lg font-bold leading-6 mb-2 text-gray-900 dark:border-gray-600 dark:text-gray-100">
                    Publisher
                  </h3>
                </div>
              </div>
              <div className="mt-5 md:mt-0 md:col-span-3 mb-8">
                <div className="shadow sm:rounded-md">
                  <div className="px-4 py-5 bg-white space-y-6 sm:p-6 rounded-md border dark:bg-gray-700 border dark:border-gray-600">
                    <div className="sm:col-span-6">
                      <label htmlFor="publisherName" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                        Publisher Name
                        <span className="text-red-600 font-bold border-red-200">
                          *
                        </span>
                      </label>
                      <div className="mt-1">
                        <input
                          placeholder="Publisher Name"
                          onChange={(e) => handleChange(e, "publisherName")}
                          defaultValue={projectData.publisherName}
                          onBlur={() => { simpleValidator.current.showMessageFor('publisherName') }}
                          type="text"
                          name="publisherName"
                          id="publisherName"
                          className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                        />
                        {simpleValidator.current.message(
                          "Publisher Name",
                          projectData.publisherName,
                          "required|alpha_space",
                          {
                            className: "text-red-600",
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Principal Investigator Section ------------------------------------------------------ */}
              <div className="md:col-span-1">
                <div className="">
                  <h3 className="text-lg font-bold leading-6 mb-2 text-gray-900 dark:border-gray-600 dark:text-gray-100">
                    Principal Investigator
                  </h3>
                </div>
              </div>
              <div className="mt-5 md:mt-0 md:col-span-3">
                <div className="shadow sm:rounded-md">
                  <div className="px-4 py-5 bg-white space-y-6 sm:p-6 rounded-md border dark:bg-gray-700 border dark:border-gray-600">

                    {/* Principal Investigator Name ------------------------------------------------------ */}
                    <div className="sm:col-span-6">
                      <label htmlFor="name" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                        Principal Investigator Name
                        <span className="text-red-600 font-bold border-red-200">
                          *
                        </span>
                      </label>
                      <div className="mt-1">
                        <input
                          placeholder="Full Name"
                          onChange={(e) => handleChange(e, "piName")}
                          defaultValue={projectData.piName}
                          onBlur={() => { simpleValidator.current.showMessageFor('name') }}
                          type="text"
                          name="name"
                          id="name"
                          className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                        />
                        {simpleValidator.current.message(
                          "Name",
                          projectData.piName,
                          "required|alpha_space",
                          {
                            className: "text-red-600",
                          }
                        )}
                      </div>
                    </div>

                    {/* Principal Investigator Email ------------------------------------------------------ */}
                    <div className="sm:col-span-6">
                      <label htmlFor="email" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                        Principal Investigator Email
                        <span className="text-red-600 font-bold border-red-200">
                          *
                        </span>
                      </label>
                      <div className="mt-1">
                        <input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="abc@gmail.com"
                          onChange={(e) => handleChange(e, "piEmail")}
                          defaultValue={projectData.piEmail}
                          className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                        />
                        {simpleValidator.current.message(
                          "Email",
                          projectData.piEmail,
                          "required|email",
                          {
                            className: "text-red-600",
                          }
                        )}
                      </div>
                    </div>

                    {/* Principal Investigator Research Affiliation ------------------------------------------------------ */}
                    <div className="sm:col-span-6">
                      <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                        Principal Investigator Research Affiliation
                        <span className="text-red-600 font-bold border-red-200">
                          *
                        </span>
                      </label>
                      <div data-cy="research-affiliation" className="mt-1 shadow-sm">
                        <Select
                          className="w-full dark:bg-gray-800 dark:border-gray-700 text-gray-800 font-normal focus:border-blue-500 focus:outline-none"
                          value={{ value: projectData.piAffiliation, label: projectData.piAffiliation }}
                          onChange={handleAffiliation}
                          options={affiliation}
                          placeholder="Choose an item"
                        />
                      </div>
                      {projectData.piAffiliation === "Other" && (
                        <div className="mt-6">
                          <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Please Enter Other Research Affiliation
                            <span className="text-red-600 font-bold border-red-200">
                              *
                            </span>
                          </label>

                          <div className="mt-1 text-sm text-gray-500">
                            <input
                              type="text"
                              name="inputPiAffiliation"
                              placeholder="Centre for Earth Observation Science, University of Manitoba"
                              onChange={(e) => handleChange(e, "inputPiAffiliation")}
                              defaultValue={projectData.inputPiAffiliation}
                              className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                            />
                            {simpleValidator.current.message(
                              "Affiliation",
                              projectData.inputPiAffiliation,
                              "required",
                              {
                                className: "text-red-600 mt-2",
                              }
                            )}
                          </div>
                        </div>
                      )}

                      {simpleValidator.current.message(
                        "Affiliation",
                        projectData.piAffiliation,
                        "required",
                        {
                          className: "text-red-600 mt-2",
                        }
                      )}
                    </div>

                    {/* Principal Investigator ORCID ------------------------------------------------------ */}
                    <div className="sm:col-span-6">
                      <label htmlFor="orc-id" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                        Principal Investigator ORCID
                      </label>
                      <div className="mt-1">
                        <input
                          placeholder=""
                          onChange={(e) => handleChange(e, "piORCID")}
                          defaultValue={projectData.piORCID}
                          type="text"
                          name="orc-id"
                          id="orc-id"
                          className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                        />
                        {projectData.piORCID === "" ? (
                          <></>
                        ) : (
                          simpleValidator.current.message(
                            "Principal Investigator orcid",
                            projectData.piORCID,
                            "required|alpha_num_dash_space",
                            {
                              className: "text-red-600",
                            }
                          )
                        )}
                      </div>
                    </div>

                    {/* Principal Investigator Role ------------------------------------------------------ */}
                    <div className="sm:col-span-6">
                      <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                        Principal Investigator Role
                        <span className="text-red-600 font-bold border-red-200">
                          *
                        </span>
                      </label>
                      <div className="mt-1 shadow-sm">
                        <Select
                          className="w-full dark:bg-gray-800 dark:border-gray-700 text-gray-800 font-normal focus:border-blue-500 focus:outline-none"
                          value={{ value: projectData.piRole, label: projectData.piRole }}
                          onChange={handleRole}
                          options={PIrole}
                          placeholder="Choose an item"
                        />
                      </div>
                      {projectData.piRole === "Other" && (
                        <div className="mt-6">
                          <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Please Enter Other Role
                            <span className="text-red-600 font-bold border-red-200">
                              *
                            </span>
                          </label>

                          <div className="mt-1 text-sm text-gray-500">
                            <input
                              type="text"
                              name="inputPiRole"
                              placeholder="Principal Investigator"
                              onChange={(e) => handleChange(e, "inputPiRole")}
                              defaultValue={projectData.inputPiRole}
                              className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                            />
                          </div>
                          {simpleValidator.current.message(
                            "Role",
                            projectData.inputPiRole,
                            "required",
                            {
                              className: "text-red-600",
                            }
                          )}
                        </div>
                      )}

                      {simpleValidator.current.message(
                        "Role",
                        projectData.piRole,
                        "required",
                        {
                          className: "text-red-600",
                        }
                      )}
                    </div>

                    <div className=" font-bold text-gray-900 sm:text-lg sm:tracking-tight lg:text-xl pt-6 pb-2 border-b-2 dark:border-gray-600 dark:text-gray-100">
                      Principal Investigator Contact Information
                    </div>

                    <div className="sm:col-span-6">
                      <label htmlFor="country" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                        Country
                        <span className="text-red-600 font-bold border-red-200">
                          *
                        </span>
                      </label>
                      <div className="mt-1 text-sm text-gray-500">
                        <CountryDropdown
                          id="country"
                          className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 font-normal dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                          value={projectData.piCountry}
                          onChange={(val) => selectCountry(val)}
                          whitelist={["CA", "US"]}
                        />
                        {simpleValidator.current.message(
                          "Country",
                          projectData.piCountry,
                          "required",
                          {
                            className: "text-red-600",
                          }
                        )}
                      </div>
                    </div>

                    {projectData.piCountry === "Canada" ? (
                      <>
                        <div className="sm:col-span-6">
                          <label htmlFor="businessAddress" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Business Address
                            <span className="text-red-600 font-bold border-red-200">
                              *
                            </span>
                          </label>
                          <div className="mt-1 text-sm text-gray-500">
                            <span>
                              <input
                                id="businessAddress"
                                type="text"
                                placeholder="123 Main street"
                                data-cy="address"
                                onChange={(e) => handleChange(e, "piAdd")}
                                defaultValue={projectData.piAdd}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />
                            </span>
                            {simpleValidator.current.message(
                              "Address",
                              projectData.piAdd,
                              "required",
                              {
                                className: "text-red-600 ",
                              }
                            )}
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 w-full py-3"> {/* Grid div start ------------------------------------------------------------------------------------- */}
                          <span className="text-sm ">
                            <label htmlFor="city" className="block text-base font-semibold text-gray-900 dark:text-gray-100 dark:text-gray-200">
                              City
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <input
                                id="city"
                                name="city"
                                type="text"
                                placeholder="Winnipeg"
                                data-cy="city"
                                onChange={(e) => handleChange(e, "piCity")}
                                defaultValue={projectData.piCity}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />

                              {simpleValidator.current.message(
                                "City",
                                projectData.piCity,
                                "required|alpha_space",
                                {
                                  className: "text-red-600 mt-2 lg:w-48",
                                }
                              )}
                            </div>
                          </span>
                          <span>
                            <label htmlFor="province" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                              Province
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <RegionDropdown
                                id="province"
                                className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 font-normal dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                                country={projectData.piCountry}
                                value={projectData.piProvince}
                                data-cy="province"
                                onChange={(val) => selectRegion(val)}
                              />
                              {simpleValidator.current.message(
                                "Province",
                                projectData.piProvince,
                                "required",
                                {
                                  className: "text-red-600 mt-2 lg:w-48",
                                }
                              )}
                            </div>
                          </span>

                          <span>
                            <label htmlFor="postal" className="block text-base font-semibold text-gray-900 dark:text-gray-100 ">
                              Postal Code
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <input
                                id="postal"
                                type="text"
                                name="postal"
                                placeholder="H0H 0H0"
                                value={projectData.tempPostalCode}
                                onChange={(e) => handleChange(e, "piPostalCode")}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />

                              {/* Canadian Postal code validation */}

                              {/* Manitoba */}
                              {projectData.piProvince === "Manitoba" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|MB",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Alberta*/}
                              {projectData.piProvince === "Alberta" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|AB",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Newfoundland and Labrador*/}
                              {projectData.piProvince ===
                                "Newfoundland and Labrador" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|NL",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Prince Edward Island*/}
                              {projectData.piProvince === "Prince Edward Island" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|PE",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Nova Scotia*/}
                              {projectData.piProvince === "Nova Scotia" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|NS",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Ontario*/}
                              {projectData.piProvince === "Ontario" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|ON",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Quebec*/}
                              {projectData.piProvince === "Quebec" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|QC",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Saskatchewan*/}
                              {projectData.piProvince === "Saskatchewan" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|SK",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*British Columbia*/}
                              {projectData.piProvince === "British Columbia" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|BC",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Yukon*/}
                              {projectData.piProvince === "Yukon" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|YT",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Northwest Territories*/}
                              {projectData.piProvince ===
                                "Northwest Territories" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|NT",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*Nunavut*/}
                              {projectData.piProvince === "Nunavut" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|NU",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}

                              {/*New Brunswick*/}
                              {projectData.piProvince === "New Brunswick" &&
                                simpleValidator.current.message(
                                  "code",
                                  projectData.piPostalCode,
                                  "required|NB",
                                  {
                                    className: "text-red-600 lg:w-48",
                                  }
                                )}
                            </div>
                          </span>

                          <span>
                            <label htmlFor="phone" className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                              Phone
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <input
                                id="phone"
                                type="text"
                                name="phone"
                                value={projectData.tempPhone}
                                onChange={(e) => handleChange(e, "piPhone")}
                                placeholder="(508) 555-1234 or 5085551234"
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />
                              {simpleValidator.current.message(
                                "Phone",
                                projectData.piPhone,
                                "required|phone",
                                {
                                  className: "text-red-600 mt-2 lg:w-48",
                                }
                              )}
                            </div>
                          </span>
                        </div> {/* Grid div end ------------------------------------------------------------------------------------- */}
                      </>
                    ) : projectData.piCountry === "United States" ? (
                      <>
                        <div className="sm:col-span-6">
                          <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Business Address
                            <span className="text-red-600 font-bold border-red-200">
                              *
                            </span>
                          </label>
                          <div className="mt-1 text-sm text-gray-500">
                            <span>
                              <input
                                type="text"
                                placeholder="123 Main street"
                                onChange={(e) => handleChange(e, "piAdd")}
                                defaultValue={projectData.piAdd}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:border-gray-600 dark:bg-gray-700"
                              />
                            </span>
                            {simpleValidator.current.message(
                              "Address",
                              projectData.piAdd,
                              "required",
                              {
                                className: "text-red-600 mt-2",
                              }
                            )}
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 w-full py-3">
                          <span>
                            <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                              City
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <input
                                name="city"
                                type="text"
                                placeholder="Amsterdam"
                                onChange={(e) => handleChange(e, "piCity")}
                                defaultValue={projectData.piCity}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />
                              {simpleValidator.current.message(
                                "City",
                                projectData.piCity,
                                "required|alpha_space",
                                {
                                  className: "text-red-600 mt-2 lg:w-48",
                                }
                              )}
                            </div>
                          </span>

                          <div>
                            <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                              State
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <RegionDropdown
                                className="py-3 px-4 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 font-normal dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                                country={projectData.piCountry}
                                value={projectData.piProvince}
                                onChange={(val) => selectRegion(val)}
                              />
                              {simpleValidator.current.message(
                                "Province",
                                projectData.piProvince,
                                "required",
                                {
                                  className: "text-red-600 mt-2 lg:w-48",
                                }
                              )}
                            </div>
                          </div>

                          <div>
                            <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                              Zip Code
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <input
                                name="postal"
                                type="text"
                                placeholder="32225, 32225-1234"
                                onChange={(e) => handleChange(e, "piZipCode")}
                                defaultValue={projectData.piPostalCode}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:border-gray-600 dark:bg-gray-700"
                              />
                              {simpleValidator.current.message(
                                "code",
                                projectData.piPostalCode,
                                "required|zipCode",
                                {
                                  className: "text-red-600 mt-2 lg:w-48",
                                }
                              )}
                            </div>
                          </div>

                          <span>
                            <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                              Phone
                              <span className="text-red-600 font-bold border-red-200">
                                *
                              </span>
                            </label>
                            <div className="mt-1 text-sm text-gray-500">
                              <input
                                id="phone"
                                type="text"
                                name="phone"
                                value={projectData.tempPhone}
                                onChange={(e) => handleChange(e, "piPhone")}
                                placeholder="(508) 555-1234 or 5085551234"
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:border-gray-600 dark:bg-gray-700"
                              />
                              {simpleValidator.current.message(
                                "Phone",
                                projectData.piPhone,
                                "required|phone",
                                {
                                  className: "text-red-600 lg:w-48",
                                }
                              )}
                            </div>
                          </span>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

      {projectData.contributorList.map((val, idx) => {
        return (
          <div key={idx} className=" max-w-2xl mx-auto ">
            <div className="py-5 bg-gray-100 dark:bg-gray-800">
              {idx !== 0 && (
                <div className=" md:grid md:grid-cols-3 md:gap-2 px-8 ">
                  <div className="md:col-span-1">
                    <div className="">
                      <h3 className="text-lg font-bold leading-6 text-gray-900 dark:border-gray-600 dark:text-gray-100">
                        Co-Investigator(s)
                      </h3>
                    </div>
                  </div>
                  <div className="mt-5 md:mt-0 md:col-span-3">
                    <div className="shadow sm:rounded-md">
                      <div className=" px-4 py-5 bg-white space-y-6 sm:p-6 rounded-md dark:bg-gray-700 border dark:border-gray-600">
                        <div className="sm:col-span-6">
                          <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Co-Investigator Name
                            <span className="text-red-600 font-bold border-red-200">
                              *
                            </span>
                          </label>
                          <div className="mt-1 text-sm text-gray-500">
                            <span className="">
                              <input
                                type="text"
                                name="name"
                                value={val.name}
                                data-cy="co-name"
                                onChange={(e) => handleChangeContributor(e, idx)}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />

                              {simpleValidator.current.message(
                                `Co-Investigator ${idx} Name`,
                                projectData.contributorList[idx].name,
                                "required|alpha_space",
                                {
                                  className: "text-red-600",
                                }
                              )}
                            </span>
                          </div>
                        </div>

                        <div className="sm:col-span-9">
                        <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Co-Investigator Role(s)
                            <span className="text-red-600 font-bold border-red-200">
                              *
                            </span>
                        </label>
                        <div className="mt-1 text-sm text-gray-500" data-cy="co-role">
                        <ReactTags
                              allowNew
                              selected={getContributorRoleChips(val.roles)}
                              suggestions={PIrole
                                 }
                              onDelete={(role) => onRoleTagDelete(idx, role)}
                              onAdd={(role) => onRoleTagAddition(idx, role)}
                              placeholderText={"Add"}
                          />
                            {simpleValidator.current.message(
                                `Co-Investigator ${idx} Role`,
                                val.roles,
                                "required|array",
                                {
                                    className: "text-red-600",
                                }
                            )}
                        </div>
                      </div>

                        <div className="sm:col-span-6">
                          <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Co-Investigator Email
                          </label>
                          <div className="mt-1 text-sm text-gray-500">
                            <span className="">
                              <input
                                type="email"
                                name="email"
                                value={val.email}
                                data-cy="co-email"
                                onChange={(e) => handleChangeContributor(e, idx)}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />

                              {val.email === "" ? (
                                <></>
                              ) : (
                                simpleValidator.current.message(
                                  "Co-Investigator Email",
                                  val.email,
                                  "required|email",
                                  {
                                    className: "text-red-600",
                                  }
                                )
                              )}
                            </span>
                          </div>
                        </div>

                        <div className="sm:col-span-6">
                          <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Co-Investigator Research Affiliation
                          </label>
                          <div data-cy="co-affiliation" className="mt-1 text-sm text-gray-500 ">
                            <span className="">
                              <Select
                                className="w-full mr-12 "
                                value={{ value: val.affiliation, label: val.affiliation }}
                                onChange={(val) => handleChangeContributorAffiliation(val, idx)}
                                options={affiliation}
                                placeholder="Choose an item"
                                name="affiliation"
                              />

                              {val.affiliation !== undefined &&
                                val.affiliation === "Other" && (
                                  <div className="mt-6">
                                    <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                                      Please Enter Other Research Affiliation
                                    </label>

                                    <div className="mt-1 text-sm text-gray-500">
                                      <input
                                        type="text"
                                        name="inputAffiliation"
                                        placeholder="Centre for Earth Observation Science, University of Manitoba"
                                        onChange={(e) => handleChangeContributor(e, idx)}
                                        defaultValue={projectData.inputAffiliation}
                                        className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                                      />
                                    </div>
                                  </div>
                                )}
                            </span>
                          </div>
                        </div>

                        <div className="sm:col-span-6">
                          <label className="block text-base font-semibold text-gray-900 dark:text-gray-100">
                            Co-Investigator ORCID
                          </label>
                          <div className="mt-1 text-sm text-gray-500">
                            <span className="">
                              <input
                                type="text"
                                name="ORCID"
                                value={val.ORCID}
                                data-cy="co-orcid"
                                onChange={(e) => handleChangeContributor(e, idx)}
                                className="py-3 px-4 block w-full focus:ring-1 outline-none shadow-sm focus:ring-blue-500 focus:border-blue-500 border-gray-300 border rounded-md text-gray-800 dark:text-gray-200 dark:border-gray-600 dark:bg-gray-800"
                              />

                              {val.ORCID === "" ? (
                                <></>
                              ) : (
                                simpleValidator.current.message(
                                  " Co-Investigator orcid",
                                  val.ORCID,
                                  "required|alpha_num_dash_space",
                                  {
                                    className: "text-red-600",
                                  }
                                )
                              )}
                            </span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              )}

              {idx !== 0 && (
                <button
                  className="flex items-center mt-4 m-auto py-2 px-4 shadow-sm text-sm font-medium rounded-md border border-1 border-red-600 hover:text-white text-red-600 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:hover:bg-gray-600  "
                  onClick={() => clickOnDelete(idx)}
                >
                  <HiOutlineTrash className="w-4 h-4 mr-2" />
                  Remove Co-Investigator
                </button>
              )}

              {idx === 0 && (
                <button
                  onClick={addNewContributor}
                  data-cy="add co-investigator"
                  className="flex items-center m-auto py-2 px-4 shadow-sm text-sm font-medium rounded-md border border-1 border-blue-600 hover:text-white text-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:text-gray-200"
                >
                  <HiPlus className="w-4 h-4 mr-2" />
                  Add Co-Investigator
                </button>
              )}
            </div>
          </div>
        );
      })}
      </div>

      <div className="flex justify-center mb-12 mt-12">
        <button
          type="submit"
          className="msm:mr-8 mr-40 py-4 px-11 border rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={(e) => previous(e)}
        >
          Previous
        </button>

        <div>
          <button
            type="submit"
            onClick={(e) => next(e)}
            data-cy="next"
            className="flex justify-center py-4 px-14 border rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Next
          </button>
        </div>
      </div>
      </div>
      
      <Footer />
    </>
  );
}